
import alertService from "./alert.service";
import http from './http.service';

class UserService {

    usuarios: any[] = [];

    constructor() {

    }

    getUsuarioById = (id: number, onSuccess: Function) => {

        if (this.usuarios.length === 0 || !this.usuarios.some(it => it.id === id)) {

            http.get('api/admin/users/findById/'+id)
                .then((data: any) => {
                    onSuccess(data);
                })
                .catch((error: any) => {
                    alertService.error(error);
                })
        }

    }

    chequerCodigo = (user: any, value:any, onSuccess: Function) => {

        if (value) {
            http.post('auth/chequearCodigo',{email: user.email, codigo: value})
                .then((data: any) => {
                    onSuccess(data.success);                    
                })
                .catch((error: any) => {
                    alertService.error(error);
                })
        }
    }

    enviarCodigoMail = (user: any, onSuccess: Function) => {

        if (user?.email) {
            http.post('auth/enviarCodigo',{email: user.email})
                .then((data: any) => {
                    onSuccess(user);
                    alertService.msg('Codigo enviado. Revisa tu correo electronico.')
                })
                .catch((error: any) => {
                    alertService.error(error);
                })
        }
    }

}


const userServiceTs = new UserService();

export default userServiceTs;